import config from '../../../config';

export const redirectToAccountAccess = guestTypeUser => {
  const url = guestTypeUser
    ? `${config('clxUrl')}/usis/login/logout?sdurl=${config(
        'clxUrl'
      )}/usis/client-portal/dashboard`
    : `${config('clxUrl')}/usis/client-portal/dashboard`;

  window.open(url, '_blank');

  return url;
};
